import React, { ReactNode } from 'react';
import { RuleSet } from 'styled-components';
import { FormBlockContainer, FormChildrenContainer } from './styled';
import { Typography } from '../../../../ui/Typography';

interface FormBlockWrapperProps {
  children: ReactNode;
  header?: string | boolean;
  required?: boolean;
  contentStyles?: RuleSet<object>;
}

export const FormBlockWrapper: React.FC<FormBlockWrapperProps> = ({
  header,
  children,
  required = false,
  contentStyles
}) => {
  return (
    <FormBlockContainer data-cy="item-form-block">
      {header && (
        <Typography
          tag="title_2_new"
          data-cy="item-form-block-header"
        >{`${header} ${required ? ' *' : ''}`}</Typography>
      )}
      <FormChildrenContainer styles={contentStyles}>
        {children}
      </FormChildrenContainer>
    </FormBlockContainer>
  );
};
